import { use, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MeContext } from '../../../contexts/me.context';

type Props = {
  children: React.ReactNode;
};

const ALLOWED_PATHS = new Set(['/settings/mfa/setup']);

/**
 * Redirects the user to /settings/mfa/setup whenever `me.mfaResetPending`
 * is true, unless they are already on that page. Used to force re-enrollment
 * after a recovery-code consume.
 */
const MfaResetGate: React.FC<Props> = ({ children }) => {
  const { me } = use(MeContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (me?.mfaResetPending && !ALLOWED_PATHS.has(location.pathname)) {
      navigate('/settings/mfa/setup', { replace: true });
    }
  }, [me?.mfaResetPending, location.pathname, navigate]);

  return <>{children}</>;
};

export default MfaResetGate;
